import { useState, useEffect, useDeferredValue } from "react";
import { Link } from "react-router-dom";
import { SchoolsList } from "../components/schoolList/schoolList";
import { Button } from "../shared/button";
import { TSchoolOutput } from "../types";
import SchoolService from "../APIService/SchoolService";

const fetchSchools = async () => {
  const response = await SchoolService.getSchoolList();
  return response.data;
};

export function EntryWorks() {
  const [schools, setSchools] = useState<TSchoolOutput[]>([]);
  const deferredSchools = useDeferredValue(schools);

  useEffect(() => {
    fetchSchools().then((schools) => {
      setSchools(schools);
    });
  }, []);

  return (
    <div className={"MainPageGrid"}>
      <div>
        <h2 style={{ textAlign: "left" }}>ВСТУПИТЕЛЬНЫЕ РАБОТЫ</h2>

        <p>
          Задания официальных вступительных работ с 2009 по 2026 годы и их
          аналоги, созданные с помощью генератора задач minimath239.
        </p>

        <p>
          На 14 августа 2026 года на сайте размещено 330 вступительных экзаменов
          в 5-е классы. Из них 245 в публичном доступе.
        </p>

        <SchoolsList schools={deferredSchools} />

        <Link to={"/exam"}>
          <Button>Все школы</Button>
        </Link>
      </div>

      <img width="278" height="303" src={"/images/inputwork3.svg"} alt="" />
    </div>
  );
}
